import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxLedger from '../util/remote/ajaxLedger';
import { useIncomingInvoice } from './IncomingInvoiceContext';

const initialState = { 
    recentLedgers: null,
    ledgerList: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    dateRange: { opening_date: "", closing_date: "" },
    fetchedPeriod: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const LedgerContext = createContext();

export const LedgerProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const {refresh: refreshInvoices} = useIncomingInvoice();

  useEffect(()=>{
    if(state.mounted){
      getTransactions();
    }
  }, [state.currentPage]);

  const getRecentLedgers = async (refresh) => {
    if(Array.isArray(state.recentLedgers) && !refresh){
      return;
    }
    // dispatch({ type: 'recentLedgers', payload: false });
    const server_response  = await ajaxLedger.listRecentTransactions();
    if(server_response.status === "OK"){
        dispatch({ type: 'recentLedgers', payload: server_response.details });
    }else{
        dispatch({ type: 'recentLedgers', payload: "404" });
    }
  };

 
  const getTransactions = async(refresh = false, period = null)=>{
    dispatch({ type: 'mounted', payload: true });
    if(refresh){
        dispatch({ type: 'ledgerList', payload: null });
        dispatch({ type: 'metaData', payload: null });
    }
    dispatch({ type: 'ledgerList', payload: null });
    const payload = {
      page: refresh ? 1 : state.currentPage,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    };
    const server_response = await ajaxLedger.filterTransactions(payload);
    if(server_response.status==="OK"){
      dispatch({ type: 'ledgerList', payload: server_response.details.data });
      dispatch({ type: 'metaData', payload: server_response.details.meta });
      dispatch({ type: 'fetchedPeriod', payload: server_response.details.period });
    }else{
      dispatch({ type: 'ledgerList', payload: "404" });
      dispatch({ type: 'metaData', payload: "404" });

    }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const refresh = async() =>{
      await getRecentLedgers(true);
      await  getTransactions(true);
      await refreshInvoices();
  }

  return(
    <LedgerContext.Provider value={{
      ...state, 
      dispatch, 
      getRecentLedgers,
      getTransactions,
      setCurrentPage,
      refresh
      }}>
      {children}
    </LedgerContext.Provider>
  )

}

export const useLedger = ()=>useContext(LedgerContext);

